export default function UploadIco() {
  return (
    <svg
      width="19"
      height="17"
      viewBox="0 0 19 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.83337 11.6663L9.16671 8.33301M9.16671 8.33301L12.5 11.6663M9.16671 8.33301V15.833M15.8334 12.2854C16.8513 11.4447 17.5 10.173 17.5 8.74967C17.5 6.21837 15.448 4.16634 12.9167 4.16634C12.7346 4.16634 12.5643 4.07134 12.4718 3.91446C11.3851 2.07037 9.37873 0.833008 7.08337 0.833008C3.63159 0.833008 0.833374 3.63123 0.833374 7.08301C0.833374 8.80476 1.52958 10.3639 2.65583 11.4943"
        stroke="#7F56D9"
        stroke-width="1.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
